import { apiV1Endpoint } from "../../../../../api/v1";
import { PaginatedApiResponse } from "../../../../../types/api-response";
import axios from "../../../../../utils/axiosInceptor";

export type CommentResponse = {
  comment: string;
  module: string;
  moduleId: string;
  commentBy: { name: string; userId: string };
  type: string;
  ticketCommentId: string;
  createdAt: string;
};

export const fetchCommentsRequest = async (ticketId: string) => {
  const url = `${apiV1Endpoint}/maintenance/ticket/getComments/${ticketId}`;
  const response = await axios.get<PaginatedApiResponse<CommentResponse[]>>(url);
  return response.data;
};
